/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const initStickyAtc = () => {
    const stickyAtc = document.getElementById('StickyAtc');
    const mainAddToCart = document.querySelector('[data-add-to-cart]:not(.sticky-atc__button)');
    
    if (!stickyAtc || !mainAddToCart) return;

    // 1. Show/Hide logic using IntersectionObserver
    const observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyAtc.classList.add('is-active');
        } else {
          stickyAtc.classList.remove('is-active');
        }
      });
    }, observerOptions);

    observer.observe(mainAddToCart);

    // 2. Add to Cart click sync
    const stickyAtcButton = stickyAtc.querySelector('[data-sticky-atc-submit]');
    if (stickyAtcButton) {
      stickyAtcButton.addEventListener('click', (e) => {
        e.preventDefault();
        mainAddToCart.click();
      });
    }

    // 3. Variant Sync
    document.addEventListener('theme:variant:change', (event) => {
      const variant = event.detail.variant;
      if (!variant) return;

      // Helper for money formatting if theme.Currency.formatMoney doesn't exist
      const formatMoney = (cents, format) => {
          if (typeof cents == 'string') cents = cents.replace('.', '');
          let value = '';
          const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          format = format || theme.moneyFormat;

          function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
              if (isNaN(number) || number == null) return 0;
              number = (number / 100.0).toFixed(precision);
              const parts = number.split('.');
              const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
              const cents = parts[1] ? decimal + parts[1] : '';
              return dollars + cents;
          }

          switch (format.match(placeholderRegex)[1]) {
              case 'amount':
                  value = formatWithDelimiters(cents, 2);
                  break;
              case 'amount_no_decimals':
                  value = formatWithDelimiters(cents, 0);
                  break;
              case 'amount_with_comma_separator':
                  value = formatWithDelimiters(cents, 2, '.', ',');
                  break;
              case 'amount_no_decimals_with_comma_separator':
                  value = formatWithDelimiters(cents, 0, '.', ',');
                  break;
          }

          return format.replace(placeholderRegex, value);
      };

      // Update price
      const priceElement = stickyAtc.querySelector('[data-sticky-atc-price]');
      const comparePriceElement = stickyAtc.querySelector('[data-sticky-atc-compare-price]');
      const badgeElement = stickyAtc.querySelector('[data-sticky-atc-badge]');

      if (priceElement) {
        priceElement.textContent = formatMoney(variant.price, theme.moneyFormat);
        priceElement.classList.toggle('sale', variant.compare_at_price > variant.price);
      }

      if (comparePriceElement) {
        if (variant.compare_at_price > variant.price) {
          comparePriceElement.textContent = formatMoney(variant.compare_at_price, theme.moneyFormat);
          comparePriceElement.style.display = '';
        } else {
          comparePriceElement.style.display = 'none';
        }
      }

      if (badgeElement) {
          if (variant.compare_at_price > variant.price) {
              const discount = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
              badgeElement.textContent = `-%${discount}`;
              badgeElement.style.display = '';
          } else {
              badgeElement.style.display = 'none';
          }
      }

      // Update image
      if (variant.featured_media) {
        const imageElement = stickyAtc.querySelector('[data-sticky-atc-image]');
        if (imageElement) {
            // Very simple image sizing for Shopify
            const src = variant.featured_media.preview_image.src;
            const sizedSrc = src.replace(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)/, '_100x100_crop_center.$1');
            imageElement.src = sizedSrc;
        }
      }

      // Update button state (Sold Out / Add to Cart)
      if (stickyAtcButton) {
          const mainButtonText = mainAddToCart.querySelector('[data-add-to-cart-text]');
          if (mainButtonText) {
              stickyAtcButton.textContent = mainButtonText.textContent;
          }
          stickyAtcButton.disabled = !variant.available;
      }
    });
  };

  // Run on load and on Shopify section load
  document.addEventListener('DOMContentLoaded', initStickyAtc);
  document.addEventListener('shopify:section:load', initStickyAtc);



  const initVerticalProductThumbs = () => {
    const galleries = document.querySelectorAll('.template-product .product-single__gallery');

    galleries.forEach((gallery) => {
      if (gallery.dataset.verticalThumbsInitialized === 'true') return;

      const slider = gallery.querySelector('[data-product-single-media-slider]');
      const thumbs = gallery.querySelector('[data-product-single-media-thumbs-vertical]');

      if (!slider || !thumbs) return;

      const thumbItems = Array.from(thumbs.querySelectorAll('[data-thumbnail-id]'));
      const slides = Array.from(slider.querySelectorAll('[data-product-single-media-wrapper]'));

      if (!thumbItems.length || !slides.length) return;

      gallery.dataset.verticalThumbsInitialized = 'true';

      const getFlickityInstance = () => {
        const FlickityConstructor = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);

        if (!FlickityConstructor || typeof FlickityConstructor.data !== 'function') {
          return null;
        }

        return FlickityConstructor.data(slider);
      };

      const setActiveThumb = (mediaId) => {
        thumbItems.forEach((thumb) => {
          thumb.classList.toggle('is-nav-selected', String(thumb.dataset.id) === String(mediaId));
        });
      };

      const getSlideIndexByMediaId = (mediaId) => {
        return slides.findIndex((slide) => {
          const slideId = slide.dataset.id;
          const slideMediaId = slide.getAttribute('data-media-id');

          return String(slideId) === String(mediaId) || String(slideMediaId).endsWith(`-${mediaId}`);
        });
      };

      const selectMedia = (mediaId) => {
        const index = getSlideIndexByMediaId(mediaId);

        if (index < 0) return;

        const flickity = getFlickityInstance();

        if (flickity && flickity.isActive) {
          flickity.select(index);
        } else {
          slides.forEach((slide, slideIndex) => {
            slide.classList.toggle('media--hidden', slideIndex !== index);
            slide.classList.toggle('is-selected', slideIndex === index);
          });
        }

        setActiveThumb(mediaId);
      };

      thumbItems.forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          selectMedia(thumb.dataset.id);
        });

        thumb.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            selectMedia(thumb.dataset.id);
          }
        });
      });

      const bindFlickitySync = () => {
        const flickity = getFlickityInstance();

        if (!flickity || flickity.agVerticalThumbsBound) return;

        flickity.agVerticalThumbsBound = true;

        const syncFromSelectedSlide = () => {
          const selectedSlide = flickity.selectedElement;
          if (!selectedSlide) return;

          const mediaId = selectedSlide.dataset.id;
          if (mediaId) setActiveThumb(mediaId);
        };

        flickity.on('change', syncFromSelectedSlide);
        flickity.on('settle', syncFromSelectedSlide);
        syncFromSelectedSlide();
      };

      bindFlickitySync();
      setTimeout(bindFlickitySync, 300);
      setTimeout(bindFlickitySync, 1000);
    });
  };

  const syncVerticalThumbsHeight = () => {
    const galleries = document.querySelectorAll('.template-product .product-single__gallery');

    galleries.forEach((gallery) => {
      const slider = gallery.querySelector('[data-product-single-media-slider]');

      if (!slider) return;

      const height = slider.getBoundingClientRect().height;

      if (height > 0) {
        gallery.style.setProperty('--ag-gallery-media-height', `${Math.round(height)}px`);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initVerticalProductThumbs();
    syncVerticalThumbsHeight();

    setTimeout(initVerticalProductThumbs, 300);
    setTimeout(initVerticalProductThumbs, 1000);

    setTimeout(syncVerticalThumbsHeight, 300);
    setTimeout(syncVerticalThumbsHeight, 1000);
  });

  document.addEventListener('shopify:section:load', () => {
    initVerticalProductThumbs();
    syncVerticalThumbsHeight();

    setTimeout(initVerticalProductThumbs, 300);
    setTimeout(syncVerticalThumbsHeight, 300);
  });

  window.addEventListener('load', syncVerticalThumbsHeight);
  window.addEventListener('resize', syncVerticalThumbsHeight);

  document.addEventListener('click', (event) => {
    if (event.target.closest('.product-single__thumbnails--vertical')) {
      setTimeout(syncVerticalThumbsHeight, 150);
    }
  });



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
